import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MenuModel } from '@app/models/menu.model'
import { MenuService } from '@app/service/admin/menu.service'
import { TranslateService } from '@ngx-translate/core'
import { PermissionService, VssAuthService } from 'projects/vss-ui/src/public-api'
import { VtSSOService } from 'projects/vss-ui/src/vss-ui/services/auth/vt-sso.service'

@Component({
  selector: 'vss-fe-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  currentLang: string = localStorage.getItem('language') || 'vi'
  listLang: any[] = []

  menus: any = []
  constructor(
    private permission: PermissionService,
    private router: Router,
    private vtSSOService: VtSSOService,
    private menuService: MenuService,
    private vssAuthService: VssAuthService,
    public translate: TranslateService,
  ) {

    translate.setDefaultLang(this.currentLang)
    translate.use(this.currentLang)
  }

  ngOnInit(): void {
    this.menus = this.permission.menuObs.getValue()
    // this.menus = this.userMenus
    this.getLang()
  }

  goTo(item: any) {

    this.router.navigateByUrl(item?.children[0]?.url || item?.children[0]?.children[0]?.url)
  }

  logout() {
    // localStorage.clear();
    // this.vssAuthService.logout()
    // this.vtSSOService.redirectToLogout();

    // localStorage.clear()
    this.vssAuthService.logout()
    // this.keycloakService.logout()
    localStorage.removeItem('logged')
  }

  //ngôn ngữ
  async getLang() {
    this.listLang = [
      {
        id: 'vi',
        value: 'MENU.LANGUAGE.VIETNAMESE',
        icon: './../../../assets/images/language-vietnamese.png'
      },
      {
        id: 'en',
        value: 'MENU.LANGUAGE.ENGLISH',
        icon: './../../../assets/images/language-english.png'
      }
    ]
  }

  trackByFn(index: number, item: any) {
    return item.id // unique id corresponding to the item
  }

  onSelectLange(lang: string): void {
    localStorage.setItem('language', lang)
    this.currentLang = lang
    this.translate.use(lang).subscribe(() => {

    })
  }

}
